import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (options: IGenericObject) => {
  const navMenuOpenKeyframes = {
    '0%': { transform: 'translateX(100%)', background: 'rgba(0, 0, 0, 0)' },
    '100%': { transform: 'translateX(0)', background: 'rgba(0, 0, 0, 0.8)' },
  };
  return StyleSheet.create({
    navOverlay: {
      position: 'fixed',
      display: 'flex',
      justifyContent: 'flex-end',
      background: options.isMenuOpen ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0)',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      inset: 0,
      width: '100vw',
      height: '100%',
      maxHeight: '100%',
      zIndex: 9999,
      // Animate Open
      animationName: navMenuOpenKeyframes,
      animationDuration: `${options.openAnimationDurationMs / 1000}s`,
      animationTimingFunction: 'linear',
      // Transition to Close
      transform: options.isMenuOpen ? 'translateX(0)' : 'translateX(100%)',
      transition: `transform ${options.openAnimationDurationMs / 1000}s linear`,
      overflow: 'hidden',
      overflowY: 'scroll',
    },
    navContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      background: palette.darkGrey,
      width: '90%',
      minHeight: '100%',
      height: 'fit-content',

      [media.tablet]: {
        display: 'none',
      },
    },
    navHeader: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      padding: 15,
    },

    hamburger: {
      position: 'relative',
      margin: '15px 0px 15px 20px',

      ':hover': {
        cursor: 'pointer',
      },

      [children('span')]: {
        width: 20,
        height: 2,
        backgroundColor: '#ecf0f1',
        display: 'block',
        margin: '4px auto',
        transition: 'all 0.3s ease-in-out',
      },

      [media.tablet]: {
        display: 'none',
      },
    },
    hamburgerActive: {
      [children('span') + ':nth-of-type(1)']: {
        transform: 'translateY(6px) rotate(45deg)',
      },
      [children('span') + ':nth-of-type(2)']: {
        opacity: 0,
      },
      [children('span') + ':nth-of-type(3)']: {
        transform: 'translateY(-6px) rotate(-45deg)',
      },
    },
  });
};
